'use client';

import { PropsWithChildren } from 'react';
import Link, { LinkProps } from 'next/link';
import { focusRing, linkTarget } from '@utils';
import { tv } from 'tailwind-variants';

interface NavLinkProps
	extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps>,
		LinkProps {
	leftIcon?: React.ReactNode;
	rightIcon?: React.ReactNode;
	theme?: 'light' | 'dark';
}

const navLink = tv({
	extend: focusRing,
	base: [
		'inline-flex items-center justify-center gap-2',
		'w-fit rounded-xs text-sm whitespace-nowrap underline decoration-1 underline-offset-2 focus-visible:underline',
	],
	variants: {
		theme: {
			light:
				'text-light-link decoration-light-link visited:text-light-link-visited visited:decoration-light-link-visited',
			dark: 'text-neutral-white decoration-neutral-white',
		},
	},
	defaultVariants: {
		theme: 'light',
	},
});

export const NavLink = ({
	href,
	children,
	className,
	theme,
	leftIcon,
	rightIcon,
	...props
}: PropsWithChildren<NavLinkProps>) => {
	return (
		<Link
			href={href}
			target={linkTarget(href?.toString())}
			className={navLink({ theme, className })}
			{...props}
		>
			{leftIcon}
			{children}
			{rightIcon}
		</Link>
	);
};
